import { render, staticRenderFns } from "./ApprovalApp.vue?vue&type=template&id=18b4211d&scoped=true"
import script from "./ApprovalApp.vue?vue&type=script&lang=js"
export * from "./ApprovalApp.vue?vue&type=script&lang=js"
import style0 from "./ApprovalApp.vue?vue&type=style&index=0&id=18b4211d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4211d",
  null
  
)

export default component.exports